/* ANDA_HUELLA_CLICK_FULLSCREEN_PATCH */(function(){
  var VIDEO_ID="9TlQr0tbkKw";
  var MODAL_ID="anda-huella-click-fullscreen-modal";
  var STYLE_ID="anda-huella-click-fullscreen-style";
  var previousHtmlOverflow="";
  var previousBodyOverflow="";
  function ensureStyle(){
    if(document.getElementById(STYLE_ID))return;
    var style=document.createElement("style");
    style.id=STYLE_ID;
    style.textContent="#"+MODAL_ID+"{position:fixed;inset:0;z-index:2147483647;display:none;align-items:center;justify-content:center;background:#000;padding:0;margin:0;box-sizing:border-box;}#"+MODAL_ID+".is-open{display:flex;}#"+MODAL_ID+" .anda-huella-fullscreen-box{position:relative;width:100vw;height:100vh;background:#000;display:flex;align-items:center;justify-content:center;overflow:hidden;}#"+MODAL_ID+" iframe{display:block;width:min(100vw,calc(100vh * 16 / 9));height:min(100vh,calc(100vw * 9 / 16));max-width:100vw;max-height:100vh;border:0;background:#000;}#"+MODAL_ID+" .anda-huella-fullscreen-close{position:absolute;top:16px;right:16px;z-index:3;width:44px;height:44px;border:0;border-radius:50%;background:rgba(0,0,0,.7);color:#fff;font-size:30px;line-height:44px;cursor:pointer;font-family:Arial,sans-serif;}#"+MODAL_ID+" .anda-huella-fullscreen-close:hover{background:rgba(232,17,42,.95);}";
    document.head.appendChild(style);
  }
  function createModal(){
    var existing=document.getElementById(MODAL_ID);
    if(existing)return existing;
    var modal=document.createElement("div");
    modal.id=MODAL_ID;
    modal.setAttribute("role","dialog");
    modal.setAttribute("aria-modal","true");
    modal.innerHTML='<div class="anda-huella-fullscreen-box"><button type="button" class="anda-huella-fullscreen-close" aria-label="Cerrar video">&times;</button><iframe title="Huella de Comunicaci&oacute;n Comercial Responsable ANDA" allow="autoplay; encrypted-media; fullscreen; picture-in-picture; accelerometer; gyroscope" allowfullscreen></iframe></div>';
    modal.addEventListener("click",function(event){if(event.target===modal)closeModal();});
    modal.querySelector(".anda-huella-fullscreen-close").addEventListener("click",function(event){event.preventDefault();event.stopPropagation();closeModal();});
    document.addEventListener("keydown",function(event){if(event.key==="Escape"&&modal.classList.contains("is-open"))closeModal();});
    document.body.appendChild(modal);
    return modal;
  }
  function openModal(){
    ensureStyle();
    var modal=createModal();
    var iframe=modal.querySelector("iframe");
    previousHtmlOverflow=document.documentElement.style.overflow||"";
    previousBodyOverflow=document.body.style.overflow||"";
    document.documentElement.style.overflow="hidden";
    document.body.style.overflow="hidden";
    iframe.src="https://www.youtube.com/embed/"+VIDEO_ID+"?autoplay=1&rel=0&playsinline=0&enablejsapi=1&modestbranding=1&iv_load_policy=3";
    modal.classList.add("is-open");
    if(modal.requestFullscreen){modal.requestFullscreen().catch(function(){});}
  }
  function closeModal(){
    var modal=document.getElementById(MODAL_ID);
    if(!modal)return;
    var iframe=modal.querySelector("iframe");
    if(document.fullscreenElement&&modal.contains(document.fullscreenElement)&&document.exitFullscreen){document.exitFullscreen().catch(function(){});}
    if(iframe)iframe.src="";
    modal.classList.remove("is-open");
    document.documentElement.style.overflow=previousHtmlOverflow;
    document.body.style.overflow=previousBodyOverflow;
  }
  function attachOverlay(){
    var frames=document.querySelectorAll('iframe[src*="'+VIDEO_ID+'"]');
    for(var i=0;i<frames.length;i++){
      var frame=frames[i];
      if(frame.closest("#"+MODAL_ID))continue;
      if(frame.getAttribute("data-anda-click-fullscreen-bound")==="true")continue;
      var parent=frame.parentElement;
      if(!parent)continue;
      if(getComputedStyle(parent).position==="static")parent.style.position="relative";
      var overlay=document.createElement("button");
      overlay.type="button";
      overlay.setAttribute("aria-label","Reproducir video en pantalla completa");
      overlay.setAttribute("data-anda-click-fullscreen-overlay","true");
      overlay.title="Reproducir video en pantalla completa";
      overlay.style.cssText="position:absolute;inset:0;z-index:5;border:0;background:transparent;padding:0;margin:0;cursor:pointer;display:block;appearance:none;-webkit-appearance:none;font-size:0;line-height:0;color:transparent;";
      overlay.addEventListener("click",function(event){event.preventDefault();event.stopPropagation();openModal();});
      parent.appendChild(overlay);
      frame.setAttribute("data-anda-click-fullscreen-bound","true");
    }
  }
  function start(){
    attachOverlay();
    if(document.body){new MutationObserver(attachOverlay).observe(document.body,{childList:true,subtree:true});}
    var attempts=0;
    var timer=setInterval(function(){attachOverlay();attempts++;if(attempts>30)clearInterval(timer);},1000);
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start);else start();
})();
